/* eslint-disable no-unused-vars */
export enum QueryKey {
  Authentication = "Authentication",
  Tenant = "Tenant",
  Role = "Role",
  Person = "Person",
  Customer = "Customer",
  GoogleCloudStorage = "GoogleCloudStorage",
  Reward = "Reward",
  RewardEvent = "RewardEvent",
  Campaign = "Campaign",
  RewardType = "RewardType",
  RequestType = "RequestType",
  Transaction = "Transaction",
  Branch = "Branch",
  CardSeries = "CardSeries",
  Level = "Level",
  CardCategory = "CardCategory",
  ReportCardStatus = "ReportCardStatus",
  ReportAgeRange = "ReportAgeRange",
  ReportRank = "ReportRank",
  ReportCampaign = "ReportCampaign",
  ReportEarnPoints = "ReportEarnPoints",
  ReportEarnStamp = "ReportEarnStamp",
  ReportRedeemPoints = "ReportRedeemPoints",
  ReportRedeemStamp = "ReportRedeemStamp",
  Request = "Request",
Registration = "Registration",
// KEY ADD
}
